import React, { useState } from "react";
import { GREY_GRADIENT_PANEL_BACKGROUND } from "../../../../constants/styles";
import {ADMIN_PANEL_BACKGROUND_COLOR } from "../../../../constants/styles";

export default function QuestionEditorCard({ question, index, onMoveUp, onMoveDown, onRemove, onSave }) {

  const [editing, setEditing] = useState(false);
  const [text, setText] = useState(question.text);
  const [type, setType] = useState(question.type || "scale");

  const [options, setOptions] = useState(question.options || [
    { label: "A", text: "", score: 0, color: "#cccccc" },
    { label: "B", text: "", score: 0, color: "#cccccc" },
    { label: "C", text: "", score: 0, color: "#cccccc" },
    { label: "D", text: "", score: 0, color: "#cccccc" }
  ]);

  const [rangeConfig, setRangeConfig] = useState(question.range || {
    rangeType: "numeric",
    from: 1,
    to: 10,
    step: 1
  });

  const cardStyle = {
    border: "1px solid #ddd",
    borderRadius: "6px",
    padding: "8px 10px",
    marginBottom: "6px",
    background : ADMIN_PANEL_BACKGROUND_COLOR,
    boxShadow: editing ? "0 2px 6px rgba(0,0,0,0.08)" : "none"
  };

  const compactRow = {
    display: "flex",
    alignItems: "center",
    gap: "8px"
  };

  const buttonStyle = {
    padding: "2px 6px",
    fontSize: "11px",
    cursor: "pointer",
    border: "1px solid #ccc",
    borderRadius: "4px",
    background: GREY_GRADIENT_PANEL_BACKGROUND 
  };

  const handleSave = () => {
    onSave({
      ...question,
      text,
      type,
      options,
      range: type === "range" ? rangeConfig : null
    });
    setEditing(false);
  };

  const updateOption = (i, field, value) => {
    const updated = [...options];
    updated[i][field] = value;
    setOptions(updated);
  };

  const updateRange = (field, value) => {
    setRangeConfig({
      ...rangeConfig,
      [field]: value
    });
  };

  return (
    <div style={cardStyle}>

      {/* COMPACT VIEW */}
      {!editing && (
        <div style={compactRow}>
          <button style={buttonStyle} onClick={() => setEditing(true)}>✏</button>
          <button style={buttonStyle} onClick={onMoveUp}>▲</button>
          <button style={buttonStyle} onClick={onMoveDown}>▼</button>
          <button style={buttonStyle} onClick={onRemove}>✕</button>
          <div style={{ fontSize: "12px", color: "#333" }}>{question.text}</div>
        </div>
      )}

      {/* EDIT VIEW */}
      {editing && (
        <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>

          {/* QUESTION TEXT */}
          <div style={{ fontSize: "12px", fontWeight: "600" }}>Question Text</div>
          <input
            value={text}
            onChange={(e) => setText(e.target.value)}
            style={{ padding: "6px", borderRadius: "4px", border: "1px solid #ccc", fontSize: "12px" }}
          />

          {/* TYPE */}
          <div style={{ fontSize: "12px", fontWeight: "600" }}>Question Type</div>
          <select
            value={type}
            onChange={(e) => setType(e.target.value)}
            style={{ padding: "6px", borderRadius: "4px", border: "1px solid #ccc", fontSize: "12px", width: "180px" }}
          >
            <option value="scale">Scale (1–10)</option>
            <option value="yesno">Yes / No</option>
            <option value="text">Free Text</option>
            <option value="multi">Multiple Choice</option>
            <option value="range">Range (Numeric / Alpha)</option>
          </select>

          {/* RANGE CONFIG */}
          {type === "range" && (
            <>
              <div style={{ fontSize: "12px", fontWeight: "600", marginTop: "6px" }}>Range Configuration</div>

              <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                <select
                  value={rangeConfig.rangeType}
                  onChange={(e) => updateRange("rangeType", e.target.value)}
                  style={{ padding: "4px", fontSize: "12px" }}
                >
                  <option value="numeric">Numeric</option>
                  <option value="alpha">Alphabetic</option>
                </select>

                <input
                  placeholder="From"
                  value={rangeConfig.from}
                  onChange={(e) => updateRange("from", e.target.value)}
                  style={{ width: "60px", padding: "4px", fontSize: "12px" }}
                />
                <input
                  placeholder="To"
                  value={rangeConfig.to}
                  onChange={(e) => updateRange("to", e.target.value)}
                  style={{ width: "60px", padding: "4px", fontSize: "12px" }}
                />

                {rangeConfig.rangeType === "numeric" && (
                  <input
                    placeholder="Step"
                    value={rangeConfig.step}
                    onChange={(e) => updateRange("step", e.target.value)}
                    style={{ width: "60px", padding: "4px", fontSize: "12px" }}
                  />
                )}
              </div>
            </>
          )}

          {/* OPTIONS + COLOUR PICKER */}
          {(type === "scale" || type === "multi") && (
            <>
              <div style={{ fontSize: "12px", fontWeight: "600", marginTop: "6px" }}>
                Answers
              </div>

              {options.map((opt, i) => (
                <div key={i} style={{ display: "flex", gap: "6px", alignItems: "center" }}>
                  <div style={{ width: "16px" }}>{opt.label}</div>
                  <input
                    placeholder="Answer text"
                    value={opt.text}
                    onChange={(e) => updateOption(i, "text", e.target.value)}
                    style={{ flex: 1, padding: "4px", fontSize: "12px" }}
                  />
                  <input
                    type="number"
                    value={opt.score}
                    onChange={(e) => updateOption(i, "score", e.target.value)}
                    style={{ width: "60px", padding: "4px", fontSize: "12px" }}
                  />

                  {/* COLOUR PICKER */}
                  <input
                    type="color"
                    value={opt.color}
                    onChange={(e) => updateOption(i, "color", e.target.value)}
                    style={{ width: "32px", height: "24px", border: "none", cursor: "pointer" }}
                    title="Pick colour"
                  />
                </div>
              ))}
            </>
          )}

          {/* SAVE / CANCEL */}
          <div style={{ display: "flex", gap: "10px", marginTop: "8px" }}>
            <button style={buttonStyle} onClick={handleSave}>Save</button>
            <button style={buttonStyle} onClick={() => setEditing(false)}>Cancel</button>
          </div>

        </div>
      )}
    </div>
  );
}
